import "./langue.scss";
//import $ from 'jquery';
